module.exports = __webpack_public_path__ + "img/check1.88439003.png";